import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo } from 'react';

/**
 * The InPageNavigationContext containing React nodes representing the elements.
 * @default {{ elements: [] }}
 */
var InPageNavigationContext = createContext({
  elements: []
});
/**
 * InPageNavigationProvider component.
 * Provides a React context for managing elements.
 *
 * @param {InPageNavigationProviderProps} props - The props for the component.
 * @param {React.ReactNode} props.children - React nodes representing the children elements.
 * @param {React.ReactNode[]} props.elements - React nodes representing the elements.
 * @returns {JSX.Element} The rendered InPageNavigationProvider component.
 */
var InPageNavigationProvider = function (_a) {
  var elements = _a.elements,
    children = _a.children;
  /**
   * Memoized context value to avoid unnecessary re-renders.
   */
  var value = useMemo(function () {
    return {
      elements: elements
    };
  }, [elements]);
  return jsx(InPageNavigationContext.Provider, {
    value: value,
    children: children
  });
};

export { InPageNavigationContext, InPageNavigationProvider };
//# sourceMappingURL=InPageNavigationContext.js.map
